export const TURBO_CHART_INNER_PADDING = 8;
export const PANES_DIVIDER_HEIGHT = 3;
export const MIN_THRESHOLD_BAND_WIDTH = 2;
export const PANE_MAX_COUNT = 5;
export const COLLAPSED_PANE_HEIGHT = 44;
export const EPISODES_BAND_HEX_ALPHA = '66';
